
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import EntryDialog from '@/components/uicomp/ModalDialog-Form-Single'
const components = {
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
    id: null,
    input: {}
  }
}

/**
 * Computed
 *
 */
const computed = {}
computed.validate = function() {
  return !!this.input.cost_delivery
}

/**
 * Methods
 *
 */
const methods = {}

methods.reset = function() {
  this.input = Object.assign({}, this.data)
}

methods.dismiss = function() {
  this.id = null
  this.$refs.EntryDialog.dismiss()
}

methods.show = function() {
  this.$refs.EntryDialog.show()
  this.reset()
}

methods.addrecord = async function() {
  const data = this.input

  this.dismiss()
  this.$emit(`success`, data)
}

/**
 * Watch
 *
 */
const watch = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
}
</script>

<style scoped>
</style>

<template>
  <EntryDialog ref="EntryDialog" :valid="validate" @submit="addrecord">
    <FormGroup>
      <TextField
        label="Ongkos Kirim"
        :forceupper=true
        v-model="input.cost_delivery" />
    </FormGroup>
  </EntryDialog>
</template>